<template>
  <v-container class="fill-height pb-0" fluid>
    <v-col cols="2" align-self="start" class="extendedSearchCol pt-0 sticky">
      <ProcedureExtendedSearch
          :table-model="tableModel"
          @reset-search="resetSearch"
      />
      <CompanyContact />
    </v-col>
    <v-col cols="10" align-self="start" class="pt-0">
      <v-row justify="center" class="d-flex">
        <v-col class="pb-1">
          <v-row>
            <v-col>
              <v-card-title>
                <v-text-field
                    class="procedureSearch"
                    variant="solo"
                    v-on:keyup.enter="quickSearch(quickSearchText)"
                    v-model="quickSearchText"
                    :label="$t('Поиск по номеру или наименованию процедуры')"
                    single-line
                    hide-details
                    clearable
                    clear-icon="mdi-close"
                    @click:clear="resetSearch"
                />
              </v-card-title>
            </v-col>
          </v-row>
          <v-chip-group class="searchLabels">
            <v-chip v-for="(searchText, index) in storedSearches"
                    closable
                    close-icon="mdi-close"
                    class="searchLabel"
                    @click="onSearchLabelClick(searchText)"
                    @click:close="removeSearchLabel(index)"
            >
              {{ searchText }}
            </v-chip>
          </v-chip-group>

          <div class="pl-5 pr-5">
            <EntityFilter :sort="sort" :tableModel="tableModel"/>

            <ProcedureCard
                v-for="object in tableModel.bind.items"
                :item="object"
                :key="object.id"
                :tableModel="tableModel"
            />
          </div>
          <div style="margin-right: 20%;">
            <Pagination
              :table-model="tableModel"
              :show-page-size-select="false"
            />
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import api from '@/api';
import RemoteTableModel from '@/components/RemoteTableModel';
import Config from '@/config';
import { formatDate, formatDateTimeNoTz } from '@/filters';
import ProcedureCard from '@/components/ProcedureCard.vue';
import EntityFilter from '@/components/EntityFilter.vue';
import ProcedureExtendedSearch from "@/components/ProcedureExtendedSearch.vue";
import Pagination from '@/components/Pagination.vue';
import CompanyContact from '@/components/CompanyContact.vue';

export default {
  name: 'PublicProcedures',
  components: {
    CompanyContact,
    ProcedureCard,
    EntityFilter,
    ProcedureExtendedSearch,
    Pagination
  },
  filters: {
    formatDate: formatDate,
    formatDateTimeNoTz: formatDateTimeNoTz,
    exists(v) {
      return v ? 'Есть' : 'Нет';
    },
  },
  data() {
    let user = Config.getUser();
    let tableModel = new RemoteTableModel({
      loader(query) {
        return api.get('/open/procedures', {query: JSON.stringify(query)});
      },
      options: {
        sortBy: [
          { key: 'p.createdAt', order: 'desc' }
        ],
      }
    });
    return {
      user: user,
      storedSearchesIndex: 'storedSearches' + user.opts.id,
      tableModel: tableModel,
      quickSearchText: '',
      pageSizes: [
        {title: '5', value: 5},
        {title: '25', value: 25},
        {title: '50', value: 50},
        {title: '100', value: 100},
      ],
      totalEntries: -1,
      loadingDialogText: null,
      procedureStatuses: {
        DRAFT: 1,
        PUBLISHED: 2,
      },
      sort: {
        icon: 'mdi-menu-down',
        current: {
          title: 'По дате размещения (сначала новые)',
          icon: 'mdi-sort-variant',
          field: 'p.publishedAt',
          order: 'desc',
        },
        items: [
          {
            title: 'По дате размещения (сначала новые)',
            icon: 'mdi-sort-variant',
            field: 'p.publishedAt',
            order: 'desc',
          },
          {
            title: 'По дате размещения (сначала старые)',
            icon: 'mdi-sort-reverse-variant',
            field: 'p.publishedAt',
            order: 'asc',
          },
          {
            title: 'По НМЦ (сначала больше)',
            icon: 'mdi-sort-variant',
            field: 'pr.startMaxPrice',
            order: 'desc',
          },
          {
            title: 'По НМЦ (сначала меньше)',
            icon: 'mdi-sort-reverse-variant',
            field: 'pr.startMaxPrice',
            order: 'asc',
          },
        ],
      },
      storedSearches: [],
    };
  },
  methods: {
    reload() {
      this.tableModel.reload();
    },
    quickSearch(quickSearchText) {
      this.addStoredSearches(quickSearchText);
      this.tableModel.quickSearch(quickSearchText);
    },
    resetSearch() {
      this.quickSearchText = '';
      this.tableModel.quickSearch(this.quickSearchText);
    },
    addStoredSearches(quickSearchText) {
      if (!this.storedSearches.includes(quickSearchText) && quickSearchText !== '') {
        if (this.storedSearches.length >= 10) {
          this.storedSearches.pop();
        }
        this.storedSearches.push(quickSearchText);
        this.saveSearchLabels();
      }
    },
    onSearchLabelClick(labelText) {
      this.quickSearchText = labelText;
      this.tableModel.quickSearch(labelText);
    },
    removeSearchLabel(index) {
      this.storedSearches.splice(index, 1);
      this.saveSearchLabels()
    },
    saveSearchLabels() {
      const labels = JSON.stringify(this.storedSearches);
      localStorage.setItem(this.storedSearchesIndex, labels);
    },
  },
  mounted() {
    if (localStorage.getItem(this.storedSearchesIndex)) {
      try {
        this.storedSearches = JSON.parse(localStorage.getItem(this.storedSearchesIndex));
      } catch (e) {
        localStorage.removeItem(this.storedSearchesIndex);
      }
    }
    this.tableModel.reload();
  },
};
</script>

<style scoped>
.fill-height {
  height: auto !important;
}

.procedureSearch {
  color: rgba(var(--black-color), 0.4);
  font-family: Abrade;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sticky {
  position: sticky;
  top: 100px;
  max-height: 100%;
  overflow-y: auto;
}

.searchLabels {
  padding: 0 16px;

  .searchLabel {
    border-radius: 20px;
    background: rgba(var(--black-color), 0.08);
  }
}

:deep(.v-field--variant-solo, .v-field--variant-solo-filled) {
  border-radius: 6px;
  border: 1px solid rgba(var(--blue-blue-secondary-hover));
  box-shadow: none;
  font-family: Abrade;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

:deep(.v-field--variant-solo:hover, .v-field--variant-solo-filled:hover) {
  border-color: rgba(var(--grey-1));
}
</style>
